export const slugifyStrings = (...args: string[]): string => {
  const lowercaseStrings = args.map((arg) => arg.toLocaleLowerCase().replaceAll(' ', '-'));
  const string = lowercaseStrings.join('-');
  return string;
};
